import type { SubscriptionIntervalType } from '@subscriptions/domain/types';
import { SubscriptionIntervals } from '@subscriptions/domain/types';

/**
 * Validated subscription interval value object.
 * The empty string represents an absent/unknown interval produced by soft-validation reconstruction.
 */
export type SubscriptionInterval = Readonly<SubscriptionIntervalType | ''>;

const validIntervals = Object.values(SubscriptionIntervals) as string[];

/**
 * Creates a validated SubscriptionInterval value object.
 *
 * @param raw - Raw interval string
 * @returns Validated SubscriptionInterval
 * @throws Error if interval is not a valid value
 */
export const createSubscriptionInterval = (raw: string): SubscriptionInterval => {
  if (!validIntervals.includes(raw)) {
    throw new Error(`Invalid subscription interval: ${raw}. Must be one of: ${validIntervals.join(', ')}`);
  }
  return raw as SubscriptionInterval;
};
